import { IExpressInterestFormPayloadValues } from "repoV2/features/CheckoutPages/modules/ExpressInterestSection/modules/ExpressInterestFormWrapper/ExpressInterestFormWrapper.interfaces";
import getCountryCodeOptionsList from "repoV2/features/CheckoutPages/utils/getCountryCodeOptionsList";
import {
    getCountryDataBasedOnTimezone,
    getUserTimezone,
} from "repoV2/features/Common/modules/Timezone/Timezone.utils";
import { INDIA_COUNTRY_DATA } from "repoV2/utils/common/location/countriesData";

export const generateExpressInterestUserDetails = (
    expressInterestFormValues: IExpressInterestFormPayloadValues
) => {
    const { countries_flag_data } = getCountryCodeOptionsList();

    const timezone = getUserTimezone();
    const { dial_code: defaultDialCode = INDIA_COUNTRY_DATA.dial_code } =
        getCountryDataBasedOnTimezone({ timezone }) || {};

    const userDetails = {
        full_name: expressInterestFormValues.name,
        email: expressInterestFormValues.email,
        phone_number: expressInterestFormValues.phone,
        country:
            countries_flag_data[
                expressInterestFormValues.country_code || defaultDialCode
            ].countryName,
        country_code: expressInterestFormValues.country_code || defaultDialCode,
        message: expressInterestFormValues.message,
        ...(expressInterestFormValues.expressInterestCustomQuestions && {
            lead_answers:
                expressInterestFormValues.expressInterestCustomQuestions,
        }),
    };

    return userDetails;
};
